import React from 'react'
import { v4 as uuidv4 } from 'uuid';
import { useStore } from "../../Store";
import { useCreateProductPage } from "../../hooks/useCreateProductPage"
import { CreateProductPageUI } from '../../components/CreateProductPageUI';

export const CreateBookPage = () => {
    const {book: product, bookCurrentStep: currentStep, bookProgressLoading: progressLoading, updateStates, bookSelectedFilesFromGallery: selectedFilesFromGallery, bookSelectedNewFiles: selectedNewFiles} = useStore((state) => state);
    const {
        dynoCategories,
        loading,
        handleBack,
        handleNext,
        createContent,
        setPrompt,
        onProductDetailSubmit,
        createProductInDB,
        isOpen,
        onOpen,
        onClose,
        generateContent,
        outline,
        setOutline,
        extractTextFromAllFiles,
        prompt,
        loadingMessage,
        isUploadingFromCreateProduct,
        onOutlineChange,
        onModuleTitleChange,
        editMode, 
        setEditMode
    } = useCreateProductPage({uuid: uuidv4(), product, currentStep, progressLoading, updateStates, type: "book"});
    
    return (
        <CreateProductPageUI
            {...{
                dynoCategories,
                loading,
                handleBack,
                handleNext,
                createContent,
                setPrompt,
                onProductDetailSubmit,
                createProductInDB,
                isOpen,
                onOpen,
                onClose,
                generateContent,
                outline,
                setOutline,
                extractTextFromAllFiles,
                prompt,
                product,
                currentStep,
                progressLoading,
                type: "book",
                updateStates, 
                selectedFilesFromGallery, 
                selectedNewFiles,
                loadingMessage,
                isUploadingFromCreateProduct,
                onOutlineChange,
                onModuleTitleChange,
                editMode, 
                setEditMode
            }}
        />
    )
}

